__webpack_require__.p = "https://smartclinic-stage.curebay.in/";